module.exports = __webpack_public_path__ + "static/media/viva-real.73ede9bd.svg";